import { CSPUrlsMap } from '../../routes/CSPUrlsMap';

export const BWMCSPConfig = {
  cspConfiguration: {
    partner: 'bwm',
    partnerTitle: 'Bow Wow Meow Pet Insurance',
    auth0Config: {
      sit: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'bwm-sit-petportal-auth.petsure.com.au',
        appClientId: 'RUW0Qvqa9WJ38mII5nDW1ahZQPPATqd9',
        cspMfaUrl: 'https://bwm-sit-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-bwm-sys.petsure.com.au/account-verification'
      },
      uat: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'bwm-uat-petportal-auth.petsure.com.au',
        appClientId: 'aIjIn5Bx17lE8EKX9Jiw216lUhIizXZI',
        cspMfaUrl: 'https://bwm-uat-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-bwm-uat.petsure.com.au/account-verification'
      },
      preprod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-preprod-auth.bowwowinsurance.com.au',
        appClientId: 'ith1u1IyCeLWxC1wEsUftDBMRuaVWVJ7',
        cspMfaUrl: 'https://bwm-preprod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal-preprod.bowwowinsurance.com.au/account-verification'
      },
      prod: {
        authenticationType: '0', // Use 0 value for Auth0 MFA Authentication type
        cspMiddlewareApiIdentifier: 'https://cspmiddlewareapi',
        appDomain: 'petportal-auth.bowwowinsurance.com.au',
        appClientId: '0DyU8DyRW0Y0ETX6qFsPf7PukScoM9Nd',
        defaultAudience: 'https://cspmiddlewareapi',
        cspMfaUrl: 'https://bwm-prod-petportal.au.auth0.com/mfa/',
        gen2CspUrl: 'https://gen2-petportal.bowwowinsurance.com.au/account-verification'
      }
    },
    liveVetConfig: {
      sit: {
        vetChatAppModule: 'bowwowmeow.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      uat: {
        vetChatAppModule: 'bowwowmeow.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      preprod: {
        vetChatAppModule: 'bowwowmeow.vetchat.com.au',
        vetChatUrl: 'https://petyellow.vchat.com.au',
        vetChatConsultationUrl: 'https://petyellow.vchat.com.au/consult'
      },
      prod: {
        vetChatAppModule: 'bowwowmeow.vetchat.com.au',
        vetChatUrl: 'https://livevet.vetchat.com.au',
        vetChatConsultationUrl: 'https://livevet.vetchat.com.au/consult'
      }
    },
    creditCardConfig: {
      sit: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      uat: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      preprod: {
        formUrl: 'https://quickweb.support.qvalent.com/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      prod: {
        formUrl: 'https://quickweb.westpac.com.au/OnlinePaymentServlet3',
        supplierBusinessCode: '022898126'
      },
      paynowSupplierBusinessCode: 'RTCC',
      paynowSupplierBusinessCodePetsure: 'RTCC_PS'
    },
    bannerImage: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/bg/bg-bwm.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/bg/bg-bwm.png'
    },
    customFaviconUrl: {
      nonprod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/favicon/bwm-favicon.png',
      prod: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/favicon/bwm-favicon.png'
    },
    headerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/logo/bwm-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/logo/bwm-logo.png',
        imageTitle: '',
        imageTitleDescription: '',
        redirectUrl: CSPUrlsMap.dashboard.url
      }
    },
    footerLogo: {
      nonprod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure-nonprod/images/footer/bwm-footer.png',
        imageTitle: 'BWM Pet Insurance',
        imageTitleDescription: 'BWM Pet Insurance'
      },
      prod: {
        imageUrl: 'https://petcdnstore.blob.core.windows.net/csp3-assets-petsure/images/footer/bwm-footer.png',
        imageTitle: 'BWM Pet Insurance',
        imageTitleDescription: 'BWM Pet Insurance'
      }
    },
    termsOfUseUrl:
      'https://petcdnstore.blob.core.windows.net/csp-common/pdfs/terms_of_use/Customer_Portal_Terms_of_Use_092024.pdf',
    header: {
      layoutConfig: {
        small: 'hamburger',
        large: 'horizontal'
      }
    },
    faqRedirection: {
      excessTooltip: {
        category: 'claims',
        question: 'How is my claim benefit calculated?'
      },
      editName: {
        category: 'policy management',
        question: `Why can't I edit my name in the Pet Portal?`
      },
      addYourVet: {
        category: 'getting started',
        question: 'Adding your vet to your account'
      }
    },
    isLiteModeEnabled: false,
    isLecBrand: true,
    gtm: {
      id: 'GTM-56PVBTDH',
      dataLayer: 'dataLayer'
    },
    seo: {
      title: 'Bow Wow Meow Pet Insurance - Pet Portal Login',
      description:
        'Access your Bow Wow Meow Pet Portal to manage your pet policy, access 24/7 Live Vet support and to submit and track your claims.'
    }
  }
};
